import React from "react";
import { useAuth } from "../context/AuthContext";
import { useIntl } from "react-intl";
import { CurrentAppVersion } from "./CurrentAppVersion";
import { checkAppVersion } from "../common/common.version.compare";
import RefreshButton from "./RefreshButton";

type DrawerProps = {
	isOpen: boolean;
	onClose: () => void;
	onLogout: () => void;
};

export default function Drawer({ isOpen, onClose, onLogout }: DrawerProps) {
	const intl = useIntl();
	const { userData } = useAuth();

	const portal = userData?.user.portals.find((f) => f != 0);

	return (
		<>
			<div
				className="position-fixed top-0 start-0 h-100 bg-white shadow d-flex flex-column"
				style={{
					width: 250,
					zIndex: 1050,
					transform: isOpen ? "translateX(0)" : "translateX(-100%)",
					transition: "transform 0.3s ease-in-out",
				}}
			>
				{/* Header */}
				<div className="p-3 border-bottom d-flex justify-content-between align-items-center">
					{portal ? (
						<img src={require(`../assets/logos/${portal}/logo.png`)} alt="Logo" className="w-50" />
					) : null}
					<button className="btn-close" onClick={onClose}></button>
				</div>

				{/* Main content */}
				<div className="p-3 flex-grow-1">
					<p className="text-secondary">
						<small>{intl.formatMessage({ id: "logged_in_as" })}</small>
					</p>
					<h6>{userData?.user?.username}</h6>
					<RefreshButton checkAppVersion={checkAppVersion} />
				</div>

				{/* Logout button at bottom */}
				<div className="p-3 border-top">
					<button className="btn btn-danger text-light w-100" onClick={onLogout}>
						{intl.formatMessage({ id: "logout" })}
					</button>
					<small className="text-secondary ">
						<CurrentAppVersion />
					</small>
				</div>
			</div>

			{/* Backdrop */}
			{isOpen && (
				<div
					className="position-fixed top-0 start-0 w-100 h-100"
					style={{
						backgroundColor: "rgba(0, 0, 0, 0.4)",
						zIndex: 1040,
					}}
					onClick={onClose}
				/>
			)}
		</>
	);
}
